export const OUTLETS = {
  Monday: { name: "The New York Times", short: "NYT", focus: "Learning Network drills" },
  Tuesday: { name: "The Washington Post", short: "WaPo", focus: "Narrative scenes" },
  Wednesday: { name: "NPR", short: "NPR", focus: "Transparent sourcing" },
  Thursday: { name: "The Economist", short: "Economist", focus: "Clarity pass" },
  Friday: { name: "The Guardian", short: "Guardian", focus: "House style" },
  Saturday: { name: "The New Yorker / The Atlantic", short: "TNY/Atlantic", focus: "Fact-checking / Pitching" }
};

export const TASKS = {
  "weeks_1_2": [
    { id: "read", title: "Read like an editor", time: "10-15 min", description: "Skim news + feature, mark lede type, nut graf, attribution" },
    { id: "brief", title: "Hard-news brief", time: "20-25 min", description: "150-250 words, inverted pyramid, AP style" },
    { id: "analysis", title: "Analysis/feature nut-graf", time: "15-20 min", description: "150-250 words, frame tension & stakes" },
    { id: "lede", title: "Lede rewrite x3", time: "6 min", description: "Summary, delayed-ID, scene-setter" },
    { id: "headline", title: "Headline pack", time: "4 min", description: "3 options: straight, kicker+hed, SEO" },
    { id: "attribution", title: "Attribution check", time: "3-5 min", description: "Attribute every fact, prefer named sources" }
  ],
  "weeks_3_4": [
    { id: "read", title: "Read like an editor", time: "10-15 min", description: "Focus on voice & clarity" },
    { id: "brief", title: "Hard-news brief", time: "20-25 min", description: "With anti-jargon pass" },
    { id: "analysis", title: "Analysis nut-graf", time: "15-20 min", description: "Economist clarity style" },
    { id: "lede", title: "Lede variations", time: "6 min", description: "Test different approaches" },
    { id: "headline", title: "Headline pack", time: "4 min", description: "Global audience awareness" },
    { id: "style", title: "Style sweep", time: "5-8 min", description: "AP + Guardian comparison" }
  ],
  "weeks_5_6": [
    { id: "read", title: "Read like an editor", time: "10-15 min", description: "Magazine-level analysis" },
    { id: "brief", title: "Extended piece", time: "25-30 min", description: "400-600 words with scene" },
    { id: "analysis", title: "Deep nut-graf", time: "15-20 min", description: "Complex stakes framing" },
    { id: "fact_check", title: "Fact-checking drill", time: "10 min", description: "New Yorker-style verification" },
    { id: "headline", title: "Magazine headlines", time: "4 min", description: "Layered, sophisticated" },
    { id: "style", title: "Ethics sweep", time: "5-8 min", description: "Fairness, completeness checks" }
  ],
  "weeks_7_8": [
    { id: "read", title: "Read like an editor", time: "10-15 min", description: "Study successful pitches" },
    { id: "brief", title: "Portfolio piece", time: "25-30 min", description: "Publication-ready quality" },
    { id: "pitch", title: "Pitch practice", time: "15 min", description: "5-7 sentence Atlantic-style pitch" },
    { id: "fact_check", title: "Full fact-check", time: "10 min", description: "Verify all claims" },
    { id: "headline", title: "Pitch headline", time: "4 min", description: "Hook + audience fit" },
    { id: "portfolio", title: "Clip polish", time: "10 min", description: "Select & refine best work" }
  ]
};

export const WEEK_FOCUSES = {
  1: { range: "1-2", focus: "Foundations", description: "Inverted pyramid, AP basics, NPR attribution" },
  2: { range: "1-2", focus: "Foundations", description: "Inverted pyramid, AP basics, NPR attribution" },
  3: { range: "3-4", focus: "Voice & Clarity", description: "Anti-jargon, Guardian style, global sensitivity" },
  4: { range: "3-4", focus: "Voice & Clarity", description: "Anti-jargon, Guardian style, global sensitivity" },
  5: { range: "5-6", focus: "Magazine Discipline", description: "New Yorker fact-checks, extended features" },
  6: { range: "5-6", focus: "Magazine Discipline", description: "New Yorker fact-checks, extended features" },
  7: { range: "7-8", focus: "Pitching & Portfolio", description: "Atlantic pitches, clip compilation" },
  8: { range: "7-8", focus: "Pitching & Portfolio", description: "Atlantic pitches, clip compilation" }
};

export const PITCH_TEMPLATE = `[HEADLINE/SLUG]

[ONE-SENTENCE HOOK - What's the story?]

WHY NOW: [Timeliness - why does this matter today?]

WHY [OUTLET]: [Audience fit - how does this serve their readers?]

CHARACTERS/SOURCES: [Who will you interview? What access do you have?]

THE REVEAL: [What will readers learn that's new?]

YOUR CREDENTIALS: [Relevant expertise or clips]`;

export const getTodayOutlet = () => {
  const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  const today = days[new Date().getDay()];
  
  if (today === 'Sunday') return { name: "Rest Day", short: "Reset", focus: "Reflect + light review"};
  return OUTLETS[today];
};

export const getWeekTasks = (weekNumber) => {
  if (weekNumber <= 2) return TASKS.weeks_1_2;
  if (weekNumber <= 4) return TASKS.weeks_3_4;
  if (weekNumber <= 6) return TASKS.weeks_5_6;
  return TASKS.weeks_7_8;
};

export const formatDate = (date = new Date()) => {
  return date.toISOString().split('T')[0];
};

